import { cn } from "@/lib/utils"
import { ReactNode } from "react"
import { Icon } from "@/icons/icon"

export type TopbarProps = {
  title?: string
  subtitle?: string
  children?: ReactNode
  titleSlot?: ReactNode
  className?: string
  slotSide?: "left" | "right"
  showBack?: boolean
  onClickBack?: () => void
}

export default function Topbar({
  title,
  subtitle,
  className,
  children,
  titleSlot,
  slotSide = "right",
  showBack,
  onClickBack,
}: TopbarProps) {
  return (
    <nav
      className={cn(
        `flex justify-between items-center bg-white shadow-xs px-4 py-3 z-10`,
        className
      )}
    >
      <div className="flex items-center">
        {slotSide === "left" && <div>{children}</div>}

        {showBack && (
          <button
            type="button"
            className="mr-4 hover:cursor-pointer"
            onClick={onClickBack}
          >
            <Icon name="ArrowRight" className="h-4 w-auto rotate-180" />
          </button>
        )}

        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-button-black font-poppins text-base font-semibold">
              {title}
            </h1>
            {titleSlot}
          </div>
          <p className="text-label-text text-xs font-medium">{subtitle}</p>
        </div>
      </div>

      <div className="flex">
        {slotSide === "right" && <div>{children}</div>}
      </div>
    </nav>
  )
}
